// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileNavigation_navigation__zPJHK {
  display: none;
}

@media (max-width: 768px) {
  .MobileNavigation_navigation__zPJHK {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--layer-bottom-nav);
    display: block;
    min-height: calc(var(--mobile-navigation-height) + var(--safe-area-bottom));
    padding-right: var(--safe-area-right);
    padding-bottom: var(--safe-area-bottom);
    padding-left: var(--safe-area-left);
    background: var(--surface-primary);
    border-top: var(--border-width) solid var(--border-color);
    box-shadow: var(--shadow-sm);
  }

  .MobileNavigation_items__YkQsS {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    align-items: center;
    min-height: var(--mobile-navigation-height);
  }

  .MobileNavigation_item__OeuTn,
  .MobileNavigation_createButton__9SxbZ {
    min-width: var(--touch-target-size);
    min-height: var(--touch-target-size);
  }

  .MobileNavigation_item__OeuTn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    padding: 0.4rem;
    color: var(--text-secondary);
    font-size: var(--icon-size-md);
  }

  .MobileNavigation_item__OeuTn span {
    font-size: var(--font-size-xs);
    font-weight: 600;
    line-height: 1.2;
  }

  .MobileNavigation_item__OeuTn:hover,
  .MobileNavigation_active__Zgbb1 {
    color: var(--action-active);
  }

  .MobileNavigation_createButton__9SxbZ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 5.2rem;
    height: 5.2rem;
    margin: -1.8rem auto 0;
    border: 0.3rem solid var(--surface-primary);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgb(0 0 0 / 22%);
    font-size: var(--icon-size-lg);
    cursor: pointer;
  }

  .MobileNavigation_createButton__9SxbZ:focus-visible,
  .MobileNavigation_item__OeuTn:focus-visible {
    outline: 0.3rem solid var(--focus-color);
    outline-offset: 0.2rem;
  }
}

.MobileNavigation_item__OeuTn { position:relative; }
.MobileNavigation_unreadBadge__Qijt\\+ { position:absolute; top:0; right:.2rem; display:grid; min-width:1.8rem; height:1.8rem; padding:0 .3rem; place-items:center; border-radius:2rem; background:var(--color-primary); color:white; font-size:1rem; font-weight:700; }
`, "",{"version":3,"sources":["webpack://./src/components/mobileNavigation/MobileNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gCAAgC;IAChC,cAAc;IACd,2EAA2E;IAC3E,qCAAqC;IACrC,uCAAuC;IACvC,mCAAmC;IACnC,kCAAkC;IAClC,yDAAyD;IACzD,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;;IAEE,mCAAmC;IACnC,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;;IAEE,wCAAwC;IACxC,sBAAsB;EACxB;AACF;;AAEA,gCAAQ,iBAAiB,EAAE;AAC3B,wCAAe,iBAAiB,EAAE,KAAK,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,eAAe,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,WAAW,EAAE,cAAc,EAAE,eAAe,EAAE","sourcesContent":[".navigation {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .navigation {\r\n    position: fixed;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: var(--layer-bottom-nav);\r\n    display: block;\r\n    min-height: calc(var(--mobile-navigation-height) + var(--safe-area-bottom));\r\n    padding-right: var(--safe-area-right);\r\n    padding-bottom: var(--safe-area-bottom);\r\n    padding-left: var(--safe-area-left);\r\n    background: var(--surface-primary);\r\n    border-top: var(--border-width) solid var(--border-color);\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n\r\n  .items {\r\n    display: grid;\r\n    grid-template-columns: repeat(5, minmax(0, 1fr));\r\n    align-items: center;\r\n    min-height: var(--mobile-navigation-height);\r\n  }\r\n\r\n  .item,\r\n  .createButton {\r\n    min-width: var(--touch-target-size);\r\n    min-height: var(--touch-target-size);\r\n  }\r\n\r\n  .item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.3rem;\r\n    padding: 0.4rem;\r\n    color: var(--text-secondary);\r\n    font-size: var(--icon-size-md);\r\n  }\r\n\r\n  .item span {\r\n    font-size: var(--font-size-xs);\r\n    font-weight: 600;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  .item:hover,\r\n  .active {\r\n    color: var(--action-active);\r\n  }\r\n\r\n  .createButton {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 5.2rem;\r\n    height: 5.2rem;\r\n    margin: -1.8rem auto 0;\r\n    border: 0.3rem solid var(--surface-primary);\r\n    border-radius: 50%;\r\n    box-shadow: 0 2px 8px rgb(0 0 0 / 22%);\r\n    font-size: var(--icon-size-lg);\r\n    cursor: pointer;\r\n  }\r\n\r\n  .createButton:focus-visible,\r\n  .item:focus-visible {\r\n    outline: 0.3rem solid var(--focus-color);\r\n    outline-offset: 0.2rem;\r\n  }\r\n}\r\n\n.item { position:relative; }\n.unreadBadge { position:absolute; top:0; right:.2rem; display:grid; min-width:1.8rem; height:1.8rem; padding:0 .3rem; place-items:center; border-radius:2rem; background:var(--color-primary); color:white; font-size:1rem; font-weight:700; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `MobileNavigation_navigation__zPJHK`,
	"items": `MobileNavigation_items__YkQsS`,
	"item": `MobileNavigation_item__OeuTn`,
	"createButton": `MobileNavigation_createButton__9SxbZ`,
	"active": `MobileNavigation_active__Zgbb1`,
	"unreadBadge": `MobileNavigation_unreadBadge__Qijt+`
};
export default ___CSS_LOADER_EXPORT___;
